<script lang="ts">
    import { afterUpdate, createEventDispatcher, onMount } from 'svelte';
    import { _ } from 'svelte-i18n';
    import { openModal, closeModal } from 'svelte-modals';

    import IconDropdown from './Icons/IconDropdown.svelte';
    import Dummy from './Dummy.svelte';
    import { getWeekdayShort } from '../utilities/Weekdays';
    import { FriendlyDateGenerator } from '../utilities/FriendlyDateGenerator';
    import type { DaysWithJobsToProcessApp } from '../components/AppMainStatus/DaysWithJobsToProcessApp';

    let m = moment;
    m.locale('pl');

    export let day: string | string[];
    export let minDay: string | null = null;
    export let maxDay: string | null = null;
    export let disabled: boolean = false;
    export let onChange: (day: string | string[]) => void = () => {
    };
    export let drops: string = 'down';
    export let opens: string = 'right';
    export let showRelativeToday: boolean = false;
    export let valid: boolean = true;
    export let autoApply: boolean = true;
    export let daysWithJobsToProcess: Record<string, number|Record<string, number>> | null = null; // klucz to data w formacie 'YYYY-MM-DD', wartość to ilość zadań do przetworzenia
    export let daysApp: DaysWithJobsToProcessApp | null = null;
    export let classForDay: (quantity: number|Record<string,number>) => Record<string,string>|null = (quantity: number|Record<string,number>) => {
        return typeof(quantity) == 'number' && quantity > 0 || quantity['to_send'] > 0 ? {red: $_('jobs_to_send')} : null;
    }
    export let presets: Record<string, string[]> = {};
    export let modal: boolean = false;

    let dateContainer: HTMLDivElement;
    let datePickerContainer: HTMLDivElement;
    let friendlyDateStart: FriendlyDateGenerator;
    let friendlyDateEnd: FriendlyDateGenerator;
    let dispatch = createEventDispatcher();
    let range: boolean = day !== null && typeof (day) === 'object';
    let dayArr: string[] = [range ? day[0] : day, range ? day[1] : null];

    // function displayOnlyDayAndMonth(date: string): string {
    //     if (date) {
    //         return date.split('-')[2] + '.' + date.split('-')[1];
    //     }
    //     return $_('date_option_not_set');
    // }

    /**
     * Czeka na pojawienie się elementu w DOM i wykonuje na nim akcję
     * @param selector - selektor jQuery
     * @param callback - funkcja do wykonania gdy element zostanie znaleziony
     * @param maxAttempts - maksymalna liczba prób (domyślnie 20)
     * @param interval - interwał między próbami w ms (domyślnie 100ms)
     */
    function waitForElement(
        selector: string,
        callback: (element: any) => void,
        maxAttempts: number = 20,
        interval: number = 100,
    ): void {
        let attempts = 0;

        const checkElement = () => {
            // @ts-ignore jQuery is not recognized
            const element = jQuery(selector);

            if (element.length > 0) {
                callback(element);
            } else if (attempts < maxAttempts) {
                attempts++;
                setTimeout(checkElement, interval);
            } else {
                console.warn(`Element ${selector} nie został znaleziony po ${maxAttempts} próbach`);
            }
        };

        checkElement();
    }

    afterUpdate(() => {
        presets = { [$_('today_preset')]: [m(), m()] };
        console.log('#i18n, presets', presets);

        // @ts-ignore moment is not recognized
        let settings = {
            alwaysShowCalendars: true,
            showCustomRangeLabel: false,
            //singleDatePicker: !range,
            autoApply: autoApply,
            drops,
            opens,
            // parentElement: datePickerContainer,
            // minYear: 2023,
            // maxYear: parseInt(m().format('YYYY'), 10),
            // startDate: day || new Date().toISOString().substring(0, 10),
            // endDate: day,
            // minDate: minDay,
            // maxDate: maxDate,
            locale: {
                format: 'YYYY-MM-DD',
                cancelLabel: $_('Cancel'),
                applyLabel: $_('Apply'),
                daysOfWeek: [
                    $_('Sun'),
                    $_('Mon'),
                    $_('Tue'),
                    $_('Wed'),
                    $_('Thu'),
                    $_('Fri'),
                    $_('Sat'),
                ],
                monthNames: [
                    $_('month_january'),
                    $_('month_february'),
                    $_('month_march'),
                    $_('month_april'),
                    $_('month_may'),
                    $_('month_june'),
                    $_('month_july'),
                    $_('month_august'),
                    $_('month_september'),
                    $_('month_october'),
                    $_('month_november'),
                    $_('month_december'),
                ],
                firstDay: 1,
            },
            applyClass: 'date-range-button-apply',
            cancelClass: 'date-range-button-cancel',
            ranges: presets,

            // Dodatkowe klasy CSS dla komórek dni
            isCustomDate(date: any) {
                const key = date.format('YYYY-MM-DD');
                if (daysApp !== null) {
                    let classNameToFind = `checking-day-with-jobs-${key}`;
                    daysApp.getDayWithAction(key, (jobsQuantity) => {
                        const selector = '.daterangepicker:visible .' + classNameToFind;

                        let elementClass = classForDay(jobsQuantity);

                        waitForElement(selector, (element) => {
                            if (elementClass) {
                                element.removeClass(classNameToFind).addClass('dot-notification');
                                element.addClass(Object.keys(elementClass).join(' '));
                            } else {
                                element.removeClass(classNameToFind);
                            }
                        });

                        if (elementClass) {
                            waitForElement('.daterangepicker:visible .drp-calendar.left', (element) => {
                                let legend = element.find('.legend-item');
                                if (legend.length === 0) {
                                    legend = document.createElement('div');
                                    legend.style.cssText = 'padding: 5px; font-size: 12px; color: #888;';
                                    legend.innerHTML = '<div class="legend-item" style="display: flex; flex-direction: row; flex-wrap: wrap; align-items: center; gap: 4px;"></div>';
                                    element.append(legend);
                                    // @ts-ignore jQuery is not recognized
                                    legend = jQuery(legend.firstChild);
                                }
                                if (legend.find('.legend-item-color'+Object.keys(elementClass)[0].split(' ').map((c) => '.'+c).join('')).length === 0) {
                                    legend.append(`<div style="display: flex; flex-direction: row; align-items: center; gap: 4px; margin-left: 7px;">
                                        <div class="legend-item-color `+Object.keys(elementClass)[0]+`"></div><div class="legend-item-label">`+Object.values(elementClass)[0]+`</div>
                                    </div>`);
                                }
                                dispatch('calendarShow', { picker: jQuery(dateContainer).data('daterangepicker') });
                            });
                        }
                    });
                    return classNameToFind;
                } else if (daysWithJobsToProcess !== null) {
                    const daysQuantity = daysWithJobsToProcess[key] || 0;
                    const elementClass = classForDay(daysQuantity);
                    return elementClass ? Object.keys(elementClass) : null;
                }
            },
        };
        // daterangepicker nie przyjmuje pustej daty - zrobiłby z niej "Invalid date" i wyrenderował kalendarz z NaN
        const today: string = m().format('YYYY-MM-DD');
        if (range) {
            const start: string = day[0] || today;
            settings['singleDatePicker'] = false;
            settings['startDate'] = start;
            settings['endDate'] = day[1] || start;
        } else {
            settings['singleDatePicker'] = true;
            settings['startDate'] = day || today;
        }
        if (minDay !== null) {
            settings['minDate'] = minDay;
        }
        if (maxDay !== null) {
            settings['maxDate'] = maxDay;
        }
        // @ts-ignore daterangepicker is not recognized
        jQuery(dateContainer).daterangepicker(settings, function(start, end, label) {
            console.log(
                'daterangepicker, New date selected: ' +
                start.format('YYYY-MM-DD') +
                ' to ' +
                end.format('YYYY-MM-DD') +
                ' (predefined range: ' +
                label +
                ')',
            );
            // day = start.format('YYYY-MM-DD');
            // if (typeof onChange === 'function') onChange(day);
        });

        // @ts-ignore daterangepicker is not recognized
        jQuery(dateContainer).on('apply.daterangepicker', function(ev, picker) {
            ev.stopPropagation(); // not works
            console.log('apply.daterangepicker 2 ', picker.startDate.format('YYYY-MM-DD'));
            if (range) {
                day[0] = picker.startDate.format('YYYY-MM-DD');
                day[1] = picker.endDate.format('YYYY-MM-DD');
            } else {
                day = picker.startDate.format('YYYY-MM-DD');
            }
            if (modal) {
                closeModal();
            }
            if (typeof onChange === 'function') onChange(day);
        });

        // @ts-ignore daterangepicker is not recognized
        jQuery(dateContainer).on('hide.daterangepicker', function(ev, picker) {
            if (modal) {
                closeModal();
            }
            if (daysApp !== null) {
                console.log('#daysApp, hide.daterangepicker, clearAll');
                daysApp.clearAll();
            }
        });

        jQuery(dateContainer).on('show.daterangepicker', function(ev, picker) {
            if (modal) {
                openModal(Dummy);
            }
            dispatch('calendarShow', { picker: picker });
        });

        jQuery(dateContainer).on('showCalendar.daterangepicker', function(ev, picker) {
            waitForElement('.daterangepicker:visible .drp-calendar.left', (element) => {
                element.find('.legend-item').parent().remove();
                dispatch('calendarShow', { picker: jQuery(dateContainer).data('daterangepicker') });
            });
            dispatch('calendarShow', { picker: picker });
        });

        // @ts-ignore daterangepicker is not recognized
        // jQuery(dateContainer).on('cancel.daterangepicker', function (ev, picker) {
        //     console.log('cancel.daterangepicker', picker.startDate.format('YYYY-MM-DD'));
        // });

        // @ts-ignore jQuery is not recognized
        jQuery('.daterangepicker')
            .css('z-index', 20000000)
            .css('box-shadow', '-1px 11px 31px -10px rgba(0, 0, 0, 0.75)');
        // .on('click', function (event) {
        //     console.log('click', event);
        //     event.stopPropagation();
        // });
        // @ts-ignore jQuery is not recognized
        // jQuery('.daterangepicker .drp-calendar').on('click', function (event) {
        //     console.log('click, drp-calendar', event);
        //     event.stopPropagation();
        // });
    });

    onMount(() => {
    });

    if (range) {
        friendlyDateStart = new FriendlyDateGenerator(day[0], showRelativeToday);
        friendlyDateEnd = new FriendlyDateGenerator(day[1], showRelativeToday);
    } else {
        friendlyDateStart = new FriendlyDateGenerator(day, showRelativeToday);
    }

    $: {
        if (range) {
            friendlyDateStart.set(day[0]);
            friendlyDateStart.setShowRelativeToday(showRelativeToday);
            friendlyDateStart = friendlyDateStart;
            friendlyDateEnd.set(day[1]);
            friendlyDateEnd.setShowRelativeToday(showRelativeToday);
            friendlyDateEnd = friendlyDateEnd;
            dayArr[0] = day[0];
            dayArr[1] = day[1];
        } else {
            friendlyDateStart.set(day);
            friendlyDateStart.setShowRelativeToday(showRelativeToday);
            friendlyDateStart = friendlyDateStart;
            dayArr[0] = day;
            console.log(
                'friendlyDate.getRelativeTodayText()',
                day,
                friendlyDateStart.getRelativeTodayText(),
            );
        }
    }
</script>

<div
    class="select-day-container"
    class:disabled
    class:invalid-input={!valid}
    on:click|stopPropagation
>
    <div class="container" bind:this={dateContainer}>
        {#if showRelativeToday}
            {#if friendlyDateStart.getRelativeTodayText() !== ''}
                <span class="bold dont-break">{$_(friendlyDateStart.getRelativeTodayText())}</span>
            {:else}
                <span class="bold dont-break">{friendlyDateStart.getDayAndMonthNumeric()}</span>
            {/if}
        {:else}
            <span class="bold">{friendlyDateStart.getDayAndMonthNumeric()}</span>
        {/if}
        <div style="display: flex; flex-direction: row; align-items: center;">
            {#if friendlyDateStart.getRelativeTodayText() !== friendlyDateStart.getDayOfWeek()}
                <span class="lite">{dayArr[0] ? '(' + $_(getWeekdayShort(dayArr[0])) + ')' : ''}</span>
            {:else if dayArr[0] === ''}
                <span class="lite italic dont-break">{$_('select_day')}</span>
            {/if}
            {#if !range}
                <IconDropdown scale={1} />
            {/if}
        </div>
        {#if range}
            <div>-</div>
            {#if showRelativeToday}
                {#if friendlyDateEnd.getRelativeTodayText() !== ''}
                    <span class="bold dont-break">{$_(friendlyDateEnd.getRelativeTodayText())}</span>
                {:else}
                    <span class="bold dont-break">{friendlyDateEnd.getDayAndMonthNumeric()}</span>
                {/if}
            {:else}
                <span class="bold">{friendlyDateEnd.getDayAndMonthNumeric()}</span>
            {/if}
            <div style="display: flex; flex-direction: row; align-items: center;">
                {#if friendlyDateEnd.getRelativeTodayText() !== friendlyDateEnd.getDayOfWeek()}
                    <span class="lite">{dayArr[1] ? '(' + $_(getWeekdayShort(dayArr[1])) + ')' : ''}</span>
                {:else if dayArr[1] === ''}
                    <span class="lite italic dont-break">{$_('select_day')}</span>
                {/if}
                <IconDropdown scale={1} />
            </div>
        {/if}
    </div>
    <div class="" bind:this={datePickerContainer}></div>
</div>

<style>
    .select-day-container {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-end;
        cursor: pointer;
        border-radius: 3px;
        padding: 0 3px;
    }

    .container {
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        column-gap: 6px;
    }

    .bold {
        font-weight: 500;
    }

    .lite {
        font-weight: 300;
    }

    .disabled {
        opacity: 0.5;
        pointer-events: none;
    }

    .relative-day {
        font-size: 12px;
        margin-top: auto;
        padding-bottom: 5px;
        font-weight: 300;
    }

    .italic {
        font-style: italic;
    }

    :global(.daterangepicker td.dot-notification) {
        position: relative;
    }

    :global(.daterangepicker td.dot-notification::after) {
        content: '';
        position: absolute;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        top: 2px;
        right: 2px;
    }
    :global(.daterangepicker td.active.dot-notification::after) {
        top: 1px;
        right: 1px;
        border: 1px solid #ffffff;
    }
    :global(.daterangepicker td.dot-notification.red::after, .daterangepicker .legend-item-color.red::after) {
        background-color: #ef5732;
    }
    :global(.daterangepicker td.dot-notification.blue::after, .daterangepicker .legend-item-color.blue::after) {
        background-color: #4978e2;
    }
    :global(.daterangepicker td.dot-notification.pale::after, .daterangepicker .legend-item-color.pale::after) {
        opacity: 0.5;
    }

    :global(.daterangepicker .legend-item-color) {
        position: relative;
    }

    :global(.daterangepicker .legend-item-color::after) {
        content: '';
        position: absolute;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        top: -3px;
        right: 1px;
    }
</style>
